//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef } from "react";
import { injectIntl } from "react-intl";
import { withRouter, Link } from "react-router-dom";
import Routes from "../../Routes";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import Main from "../../components/main/Main";
import ReviewCard from "../../components/display/ReviewCard";
import UserNav from "../../components/navigations/UserNav";
import MainNav from "../../components/navigations/MainNav";
import ToggleLayout from "../../components/layout/ToggleLayout";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";
import Title from "../../components/text/Title";
import Message from "../../components/alerts/Message";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import ParseHTML from "../../functions/ParseHTML";
import validateData from "../../functions/validateData";

// DATA MODEL
import stageDataModel from "../../data_model/review_admin/stage/stage_data";
import stagesDataModel from "../../data_model/review_admin/dashboard/stages";

function Stage({ match, intl, history }) {
  const isInitialMount = useRef(false);
  const _id = 43892048293043;
  const dispatch = useDispatch();

  const [allStages, setAllStages] = useState();
  const [activeReviewStage, setReviewStageActive] = useState();
  const [reviewers, setReviewers] = useState();
  const reduxState = useSelector(state => state);
  const sizeOfTheScreen = useSelector(store => store.app.sizeOfTheScreen);

  const getMenuData = () => {
    AJAX()
      .getReviewStages(_id, reduxState)
      .then(res => {
        const isMenuDataValid = validateData(
          "ReviewAdmin > Stage > AJAX().getReviewStages",
          res,
          stagesDataModel
        );
        if (isMenuDataValid) {
          removeUpcomingStages(res.data);
          setAllStages(res.data.stages);
        }
      });
  };

  const getMainData = () => {
    AJAX()
      .getReviewStage(_id, reduxState, match.params.id)
      .then(res => {
        const isStageDataValid = validateData(
          "ReviewAdmin > Stage > AJAX().getReviewStage",
          res,
          stageDataModel
        );
        if (isStageDataValid) {
          setReviewStageActive(res.data.stage);
          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: res.data.stage.id },
          });
        }

        AJAX()
          .get(_id, res.data.stage.assignments_url)
          .then(res => {
            if (res.data.data.length !== 0) {
              if (reduxState.app.sizeOfTheScreen === "desktop") {
                dispatch({ type: ACTIONS.SHOW_HELLPER_SIDE_NAV });
              }
              setReviewers(res.data.data);
            }
          });
      });
  };

  const init = useCallback(() => {
    dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_PRESENT });
    sizeOfTheScreen !== "mobile" && dispatch({ type: ACTIONS.SHOW_HELLPER_SIDE_NAV });
    getMenuData();
    getMainData();
  }, [getMenuData, getMainData, sizeOfTheScreen]);

  useEffect(init, []);

  useEffect(() => {
    if (isInitialMount.current) {
      getMainData();
    } else {
      isInitialMount.current = true;
    }
  }, [match]);

  const removeUpcomingStages = stagesData => {
    const stageData = JSON.parse(JSON.stringify(stagesData));
    stageData.stages = stageData.stages.filter(i => i.in_range != "-1");
    return stageData;
  };

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
  };

  // Handle reviewer click - navigate to reviewer assignments
  const handleReviewerClick = reviewer => {
    const stageId = activeReviewStage.id;
    const profileId = reviewer.profile?.id || reviewer.profile_id;

    history.push(`${Routes.reviewAdminReviewerAssignments().path}/${stageId}/${profileId}`);
  };

  useEffect(() => {
    return () => {
      AJAX().cancelRequest(_id);
      dispatch({ type: ACTIONS.HIDE_HELLPER_SIDE_NAV });
      dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_NOT_PRESENT });
    };
  }, [_id]);

  return (
    <NewAppHOC>
      <MainAsideNav>
        <div className="__n_bs">
          <Link to="/ui/review_admin/dashboard">
            <Layout flex>
              <div>
                <Icon
                  iconId="categoriesFull"
                  addClass="c1 __n_bi"
                  style={{ marginRight: ".7rem" }}
                />
              </div>
              <Title tagName="h1" addClass="c16" removeWeight>
                {intl.formatMessage({ id: "reviewAdminDashboard" })}
              </Title>
            </Layout>
          </Link>
          {activeReviewStage && (
            <div>
              <Link to={`/ui/review_admin/stage/${activeReviewStage.id}`}>
                <Layout flex>
                  <div>
                    <Icon
                      iconId="categoriesFull"
                      addClass="c1 __n_bi"
                      style={{ marginRight: ".7rem" }}
                    />
                  </div>
                  <Title tagName="h1" addClass="c16">
                    {activeReviewStage.title}
                  </Title>
                </Layout>
              </Link>

              <ParseHTML html={activeReviewStage.description} />
            </div>
          )}
          {allStages && (
            <MainNav
              clicked={handleNavItemClick}
              title={intl.formatMessage({ id: "reviewStage" })}
              data={allStages}
              linkTo={Routes.reviewAdminStage().path}
              activeItem={match.params.id}
            />
          )}
        </div>
      </MainAsideNav>
      <Main>
        {activeReviewStage && (
          <ToggleLayout id="986436795436" title={activeReviewStage.title}>
            {activeReviewStage.collections &&
              activeReviewStage.collections.map(collection => {
                collection.in_range = activeReviewStage.in_range;

                return (
                  <ReviewCard
                    downloadLocation={`${collection.buttons.export_xlsx.link}`}
                    popoverStatsFor="judges"
                    footerTwo
                    key={collection.id}
                    data={collection}
                    clickTarget={Routes.reviewAdminCollection().path}
                  />
                );
              })}
          </ToggleLayout>
        )}
      </Main>
      <HelperAsideNav preventFromClosing>
        <Title style={{ marginBottom: "3.5rem" }}>{intl.formatMessage({ id: "stageJury" })}</Title>
        {reviewers && reviewers.length !== 0 && (
          <UserNav
            list={reviewers}
            popoverStatsFor="judges"
            onItemClick={handleReviewerClick}
            clickable
          />
        )}
        {reviewers && reviewers.length === 0 && (
          <Message msg={intl.formatMessage({ id: "projectNotAssigned" })} textOnly />
        )}
      </HelperAsideNav>
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(Stage));
